module.exports = __webpack_public_path__ + "img/188.ae995737.jpg";